import { useState } from 'react';
import { Link } from 'react-router-dom';
import { subscribeToNewsletter } from '../../lib/forms';
import {
  IconBrandInstagram,
  IconBrandFacebook,
  IconBrandWhatsapp,
} from '@tabler/icons-react';
import { useSiteContent } from '../../context/SiteContentContext';
import GuyanaStripe from './GuyanaStripe';
import './Footer.css';

export default function Footer() {
  const { c } = useSiteContent();
  const [email, setEmail] = useState('');
  const [joining, setJoining] = useState(false);
  const [joined, setJoined] = useState(false);
  const [joinError, setJoinError] = useState('');

  async function handleJoin(e) {
    e.preventDefault();
    if (joining) return;
    setJoining(true);
    setJoinError('');
    const res = await subscribeToNewsletter(email);
    setJoining(false);
    if (res.error) setJoinError(res.error);
    else setJoined(true);
  }

  return (
    <>
      <section className="newsletter">
        <h3 className="newsletter__heading">{c('newsletter_heading', 'Stay in the loop')}</h3>
        <p className="newsletter__desc">{c('newsletter_desc')}</p>
        {joined ? (
          <p className="newsletter__msg" role="status">Thanks for joining! You're on the list.</p>
        ) : (
          <form className="newsletter__form" onSubmit={handleJoin}>
            <input
              type="email"
              className="newsletter__input"
              placeholder="Your email address"
              aria-label="Email for newsletter"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="newsletter__btn" disabled={joining}>
              {joining ? 'Joining…' : 'Join'}
            </button>
          </form>
        )}
        {joinError && <p className="newsletter__msg newsletter__msg--error" role="alert">{joinError}</p>}
      </section>

      <GuyanaStripe />

      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand-col">
            <div className="footer__brand">
              Andre <span className="footer__brand-m">M</span> Leather
            </div>
            <p className="footer__tagline">{c('footer_tagline')}</p>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Shop</h4>
            <ul className="footer__links">
              <li><Link to="/shop">All bags</Link></li>
              <li><Link to="/shop">Briefcases</Link></li>
              <li><Link to="/shop">Totes</Link></li>
              <li><Link to="/shop">Messengers</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Info</h4>
            <ul className="footer__links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/care-guide">Care guide</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Policies</h4>
            <ul className="footer__links">
              <li><Link to="/policies">Returns</Link></li>
              <li><Link to="/policies">Shipping</Link></li>
              <li><Link to="/policies">Privacy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <span className="footer__copy">
            {c('footer_copyright')}
            <Link to="/admin" className="footer__admin-link">Admin login</Link>
          </span>
          <div className="footer__socials">
            <a href="https://instagram.com/andremleather" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <IconBrandInstagram size={17} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <IconBrandFacebook size={17} />
            </a>
            <a href="https://wa.me/5920000000" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <IconBrandWhatsapp size={17} />
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}
